export function setMenuOffset() {
	let root = document.documentElement;
	let header = document.querySelector('#header');
	let menuOffset = header.getBoundingClientRect().height;
	root.style.setProperty('--menu-offset', menuOffset + 'px');
}
